module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-book"
    }
  }, [_c('h1', [_vm._v("About the Book")]), _vm._v(" "), _c('p', [_vm._v("Wilf Gilvary is a teenage wizard who is terrified of using magic. When his father dies under mysterious circumstances, Wilf is plunged into the middle of a political struggle between the witches and wizards in the magical realm. He’d rather play soccer than practice magic, but he’s forced to make a choice between the life of a normal teen and one of wizardry after a powerful virus begins to decimate the witch community. The cure is spellbound in a journal Wilf inherited from his father and when his friend Katryna contracts the virus, Wilf understands that he must overcome his fear of magic to unlock the journal’s secrets—but will it be too late to save her?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0